var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container as-flex main-start" }, [
    _vm.showBar
      ? _c("div", { staticClass: "side-bar" }, [_c("sideBar")], 1)
      : _vm._e(),
    _vm._v(" "),
    _vm.showBar
      ? _c("div", { staticClass: "top-bar" }, [_c("topBar")], 1)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { class: ["content", _vm.showBar ? "" : "noBarContent"] },
      [_c("router-view", { staticClass: "router-view" })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }